import { AppConfig } from './app-config';

/**
 * AppConfig drawn from window global variables.
 */
export class AppConfigFromWindowContext extends AppConfig {
  constructor(windowConfig: AppConfig) {
    super();

    this.apiEndpoint = windowConfig.apiEndpoint;
    this.beta = windowConfig.beta;
    this.error = windowConfig.error;
    this.isEmbeddedMode = windowConfig.isEmbeddedMode;
    this.ltiRelinkUrl = windowConfig.ltiRelinkUrl;
    this.personaEndpoint = windowConfig.personaEndpoint;
    this.personaOrigin = windowConfig.personaOrigin;
    this.oauthAppId = windowConfig.oauthAppId;
    this.talisLoginProvider = windowConfig.talisLoginProvider;
    this.session = windowConfig.session;
    this.bookmarkingExtensionUrl = windowConfig.bookmarkingExtensionUrl;
    this.tenant = windowConfig.tenant;
  }
}
